//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { playingField_detail } from '@/apis/stadium'
export default {
    data() {
        return {
            id: 0,
            item: {}
        }
    },
    mounted() {
        this.id = this.$route.params.id;
        if (this.id > 0) {
            this.onPageLoad();
        }
    },
    methods: {
        async onPageLoad() {
            try {
                const res = await playingField_detail(this.id);
                this.item = res.data;
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        handleToEdit() {
            this.$router.push(`/stadium/form/${this.id}`);
        }
    }
}
